<template>
  <Layout
    :title="meta.title"
    max-width="100%"
  >
    <section class="is-card form-list">
      <base-tab
        v-model="currentStep"
        :arr="steps"
        :completed-steps="completedSteps"
        version="v2"
        box=""
        arr-prop="name"
        complete-effect
      />

      <div class="step__container">
        <div class="columns">
          <template v-if="!isMobile && currentStep !== 6">
            <div class="step__details column is-narrow">
              <p>
                Valor a receber
              </p>
              <p>
                <span>{{ stateConsult.wish_amount | money }}</span>
              </p>
              <p>
                Parcelamento
              </p>
              <p>
                <span>
                  {{ stateConsult.installments }}x
                  {{ stateConsult.installment_value | money }}
                </span>
              </p>
              <p>
                Esteira
              </p>
              <p>
                <span>{{ stateConsult.supplier_name }}</span>
              </p>
            </div>
            <div class="column divider" />
          </template>

          <div class="column">
            <component
              :is="steps[currentStep].component"
              :account-data="accountData"
              class="step"
              @next="handleNextStep"
              @back="goBack"
            />
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { toast } from 'bulma-toast';

import seo from '@/utils/seo';
import config from '@/data/config';

import loadingMixin from '@/mixins/loadingView.mixin';
import roleManagerMixin from '@/mixins/roleManager.mixin';

import Layout from '@/layouts/Layout.vue';
import BaseDropmenu from '@/components/BaseDropmenu.vue';
import BaseTab from '@/components/BaseTab.vue';

import {
  clients as ClientAPI,
} from '@/services';

export default {
  name: 'CGVData',
  components: {
    Layout,
    BaseDropmenu,
    BaseTab,
  },
  mixins: [loadingMixin, roleManagerMixin],
  data() {
    return {
      meta: {
        title: 'Nova Proposta',
      },
      message: {
        error: '',
      },
      accountData: {},
      currentStep: 0,
      completedSteps: [],
      menuHelpConfig: {
        title: 'Passo a passo',
        text: `
          Confirma todos os dados antes de enviar a proposta.
        `,
        options: [
          {
            title: 'Dados pessoais do cliente',
            text: `
              Digite com cuidado todos os dados do seu cliente, certifique-se que o número de celular esteja correto, ele será utilizado para efetivar a proposta.
            `,
          },
          {
            title: 'Tenha os dados do documento em mãos',
            text: `
              Preencha os dados referente ao documento do seu cliente.
            `,
          },
          {
            title: 'Informações do veículo',
            text: `
              Confirme os dados do veículo e preencha os dados solicitados, essa etapa é importante para certificar qual veículo será usado como garantia.
            `,
          },
          {
            title: 'Informações profissionais',
            text: `
              Preencha os dados referente a situação profissional do seu cliente.
            `,
          },
          {
            title: 'Endereço',
            text: `
              Insira um comprovante de residência no nome do seu cliente, sendo obrigatoriamente uma conta de consumo..
            `,
          },
          {
            title: 'Dados bancário',
            text: `
              Lembre-se que o banco precisa ter obrigatoriamente a mesma titularidade da pessoa cadastrada.
            `,
          },
          {
            title: 'Confirme os dados',
            text: `Revise todos os dados antes de enviar a proposta.
            `,
          },
          {
            title: 'Agora é com a BMP!',
            text: `
              A proposta criada é enviada para os analistas de crédito do nosso banco parceiro <strong>BMP</strong>, certifique-se que o telefone celular e e-mail cadastrados estejam corretos e validados. Toda comunicação após o lançamento da proposta será feita diretamente com o cliente.
            `,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    ...mapState({
      stateConsult: (state) => state.consult.consult,
      suppliers: (state) => state.app.suppliers,
    }),
    steps() {
      return [
        {
          name: 'Informações pessoais',
          component: () => import('@/components/CGVData/BasicData.vue'),
        },
        {
          name: 'Documento',
          component: () => import('@/components/CGVData/CNHData.vue'),
        },
        {
          name: 'Veículo',
          component: () => import('@/components/CGVData/VehicleData.vue'),
        },
        {
          name: 'Profissão',
          component: () => import('@/components/CGVData/ProfessionalData.vue'),
        },
        {
          name: 'Endereço',
          component: () => import('@/components/CGVData/AddressData.vue'),
        },
        {
          name: 'Dados bancários',
          component: () => import('@/components/CGVData/BankData.vue'),
        },
        {
          name: 'Revisão',
          component: () => import('@/components/CGVData/DataReview.vue'),
        },
      ];
    },
  },
  async mounted() {
    await this.getSuppliersList(config.PRODUCT_ID_CGV);
    if (this.stateConsult.document) await this.getAccount();
  },
  methods: {
    // utils
    ...mapActions({
      setConsult: 'consult/SET_CONSULT',
      getSuppliersList: 'app/SET_SUPPLIERS',
    }),
    async handleNextStep(formData) {
      await this.handleMerge(formData);
      const previousStep = this.currentStep;
      const newStep = this.currentStep + 1;

      this.currentStep = newStep;

      if (!this.completedSteps.includes(previousStep)) {
        this.completedSteps.push(previousStep);
      }

      if (!this.completedSteps.includes(newStep)) {
        this.completedSteps.push(newStep);
      }
    },

    // handlers
    handlerError(err, target = 'error') {
      let message = err?.response?.data?.error?.message
        || (err?.error?.response?.data?.error?.message
          || err?.error?.data?.message
          || err?.message
          || err);

      if (err?.response?.data?.error?.errors) {
        const errors = Object.values(err?.response?.data?.error?.errors);

        message = message.concat(`<br> - ${errors.map((error) => error).join('<br> - ')}`);
      }

      this.$set(this.message, target, message);

      toast({
        message: this.message[target],
        type: 'is-danger',
        dismissible: true,
        pauseOnHover: true,
        animate: { in: 'fadeIn', out: 'fadeOut' },
        position: 'top-center',
        closeOnClick: true,
        duration: 10000,
      });
    },
    goBack() {
      if (this.currentStep === 0) {
        this.$router.push({ name: 'cgv-consult' });
      } else {
        this.currentStep = this.currentStep - 1;
      }
    },
    handleMerge(data) {
      this.setConsult({
        ...this.stateConsult,
        ...data,
      });
    },
    // API
    getAccount() {
      this.loading = true;
      ClientAPI.checkUniqueAccount({ document: this.stateConsult.document })
        .then(({ data }) => {
          const account = {
            ...data.data,
          };
          this.accountData = account;

          this.setConsult({
            account,
            ...this.stateConsult,
          });
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>
<style lang="scss" scoped>
.form-list {
  background-color: #FFF;
}
.step {
  &__container {
    > .columns {
      padding: 2rem 0 1rem;

      > .column {
        padding: 2rem 3rem 0;

        &:first-child {
          padding-left: 1rem;
        }

        &:last-child {
          padding-right: 1rem;
        }
      }

      > .divider {
        width: 0px;
        padding: 0px;
        border-right: 2px solid map.get($stone-types, '200');

        flex: 0 0 0;
      }
    }
  }

  &__details {
    padding: 32px;
    color: map.get($stone-types, '700');

    p {
      margin-bottom: 1rem;
    }

    span {
      margin-left: 1rem;
      font-weight: bold;
    }
  }

  &::v-deep {
    .font-lg.is-bolder {
      margin-bottom: 10px;
    }
  }
}

.grid {
  display: grid;
  row-gap: 1rem;
}

.control {
  margin-top: 16px;
}
</style>
